import { z } from 'zod'

import { listQueryZodFields } from './system'
import { WebhookEventStatus } from '../constants/webhookEvent'
import { WebhookEventType } from '../constants/webhook'
import { dbEntitySchema } from './system'

const responseSchema = z.object({
  status: z.number().optional(),
  response: z.record(z.any()).optional(),
  created: z.date().optional(),
})

export const webhookEventSchema = dbEntitySchema.extend({
  organization: z.string(),
  venue: z.string(),
  webhook: z.string(),
  payload: z.object({
    type: z.nativeEnum(WebhookEventType),
    data: z.record(z.any()).optional(),
  }),
  latestResponse: responseSchema.nullish(),
  responses: z.array(responseSchema).nullish(),
  status: z.nativeEnum(WebhookEventStatus),
  attempts: z.number().min(0),
})

export const webhookEventListArgsSchema = z.object({
  ...listQueryZodFields,
  organizationId: z.string().optional(),
  webhookId: z.string().optional(),
  venueId: z.string().optional(),
})
export const webhookEventCreateArgsSchema = webhookEventSchema
  .omit({
    id: true,
    _id: true,
    deleted: true,
    organization: true,
    venue: true,
    webhook: true,
    created: true,
    modified: true,
    attempts: true,
  })
  .extend({
    venueId: z.string(),
    webhookId: z.string(),
  })

export const webhookEventUpdateByIdArgsSchema = webhookEventSchema.pick({
  status: true,
})

//responses
export const webhookEventListResponseSchema = z.object({
  data: z.array(webhookEventSchema),
})
